import React from "react";
import classes from "./BackDrop.module.css";

function Backdrop(clicked) {
  return <div className={classes.backdrop} onClick={clicked.cancel}/>;
}

export function DoubleBackdrop(clicked) {
  return <div className={classes.dbackdrop} onClick={clicked.cancel}/>;
}

export default Backdrop;
